import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { WorkOrderCompanyInformationComponent } from './work-order-company-information.component';
import { CtExpansionPanelModule } from '@ctsolution/ct-framework';
import { LeadInformationFormService } from 'projects/ct-manager/src/app/components/lead/lead-edit/lead-information-form/lead-information-form.service';
import { CompanyInformationService } from 'projects/ct-manager/src/app/components/company/company-information/company-information.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule,
    CtExpansionPanelModule
  ],
  declarations: [WorkOrderCompanyInformationComponent],
  exports: [WorkOrderCompanyInformationComponent],
  // LeadInformationFormService viene fornito qui perché non è globale:
  // ha una cache in-memory che vogliamo condividere tra le istanze
  // dello stesso modulo, ma isolata dal contesto lead.
  providers: [LeadInformationFormService, CompanyInformationService]
})
export class WorkOrderCompanyInformationModule { }
